/* 30.09.2026: винесено з layout/theme.liquid (раніше inline на кожній сторінці), підключено з defer */
// НАСТРОЙКИ - здесь можно менять селекторы
const CONFIG = {
    // Селекторы для поиска цвета (источники)
    sourceSelectors: [
        '.product-information',
        '.abcde',
    ],
    
    // Селекторы куда применять цвет (цели)
    targetSelectors: [
        '.header__row',
        '.menu-drawer',
        '.overflow-menu'
    ],
    
    // CSS-переменные для поиска цвета (в порядке приоритета)
    colorVariables: [
        '--color-background',
    ]
};

console.log('🔍 Начинаем поиск цвета...');
console.log('Ищем в селекторах:', CONFIG.sourceSelectors);

let foundColor = null;
let sourceInfo = null;

// Перебираем все возможные селекторы-источники
for (let selector of CONFIG.sourceSelectors) {
    const elements = document.querySelectorAll(selector);
    
    if (elements.length > 0) {
        console.log(`✅ Найден селектор: ${selector} (${elements.length} элементов)`);
        
        const element = elements[0];
        const elementStyle = getComputedStyle(element);
        
        // Перебираем CSS-переменные
        for (let cssVar of CONFIG.colorVariables) {
            const color = elementStyle.getPropertyValue(cssVar).trim();
            
            if (color && color !== '' && color !== 'initial' && color !== 'inherit') {
                foundColor = color;
                sourceInfo = {
                    selector: selector,
                    variable: cssVar,
                    element: element
                };
                console.log(`🎨 Найден цвет: ${color} в ${selector} (${cssVar})`);
                break;
            }
        }
        
        // Если нашли цвет, выходим из цикла
        if (foundColor) break;
        
        // Если CSS-переменные не дали результат, попробуем обычный backgroundColor
        const bgColor = elementStyle.backgroundColor;
        if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
            foundColor = bgColor;
            sourceInfo = {
                selector: selector,
                variable: 'backgroundColor',
                element: element
            };
            console.log(`🎨 Найден цвет: ${bgColor} в ${selector} (backgroundColor)`);
            break;
        }
    } else {
        console.log(`❌ Селектор не найден: ${selector}`);
    }
}

// 07.10.2026: світлий фон секції (оффер «Надішліть фото», схема #f8f8f8) — шапку НЕ фарбуємо,
// інакше білий логотип і меню зникають на білому. Шапка лишається своєю схемою (помаранчевою).
if (foundColor) {
    var btRgb = (foundColor.match(/[\d.]+/g) || []).map(Number);
    if (foundColor.charAt(0) === '#') {
        var btHex = foundColor.slice(1);
        if (btHex.length === 3) btHex = btHex.split('').map(function (c) { return c + c; }).join('');
        btRgb = [0, 2, 4].map(function (i) { return parseInt(btHex.substr(i, 2), 16); });
    }
    if (btRgb.length >= 3 && (0.2126 * btRgb[0] + 0.7152 * btRgb[1] + 0.0722 * btRgb[2]) / 255 > 0.8) {
        console.log('☀️ Светлый фон секции — шапку не перекрашиваем');
        foundColor = null;
    }
}

// Применяем найденный цвет ко всем целевым элементам
if (foundColor && sourceInfo) {
    console.log(`\n🚀 Применяем цвет ${foundColor} к целевым селекторам`);
    
    let totalElementsProcessed = 0;
    
    // Проходим по всем целевым селекторам
    CONFIG.targetSelectors.forEach(targetSelector => {
        const targetElements = document.querySelectorAll(targetSelector);
        
        if (targetElements.length > 0) {
            targetElements.forEach((element, index) => {
                element.style.backgroundColor = foundColor;
                element.style.setProperty('--color-background', foundColor);
                console.log(`✅ Элемент ${index + 1} (${targetSelector}) окрашен`);
                totalElementsProcessed++;
            });
        } else {
            console.log(`❌ Целевые элементы не найдены: ${targetSelector}`);
        }
    });
    
    if (totalElementsProcessed > 0) {
        console.log(`\n🎉 Успешно применен цвет!`);
        console.log(`Источник: ${sourceInfo.selector} (${sourceInfo.variable})`);
        console.log(`Цвет: ${foundColor}`);
        console.log(`Применено к: ${totalElementsProcessed} элементов`);
    }
} else {
    console.log('\n❌ Цвет не найден ни в одном из селекторов');
    console.log('Проверьте:');
    console.log('1. Существуют ли элементы с указанными селекторами');
    console.log('2. Есть ли у них CSS-переменные или background-color');
}

// Итоговый отчет
console.log('\n📊 ИТОГОВЫЙ ОТЧЕТ:');

console.log('\nИсточники цвета:');
CONFIG.sourceSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    console.log(`${selector}: ${elements.length > 0 ? '✅' : '❌'} (${elements.length} элементов)`);
});

console.log('\nЦелевые элементы:');
CONFIG.targetSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    console.log(`${selector}: ${elements.length > 0 ? '✅' : '❌'} (${elements.length} элементов)`);
    
    if (elements.length > 0) {
        elements.forEach((el, i) => {
            const currentBg = getComputedStyle(el).backgroundColor;
            console.log(`  Элемент ${i + 1}: ${currentBg}`);
        });
    }
});
